
import classNames from "classnames";
import { ChangeEvent, forwardRef, HTMLInputTypeAttribute } from "react";
import Icon, { IconName } from "../assets/icons";


interface InputProps {
  label?: string;
  placeholder?: string;
  className?: string;
  type?: HTMLInputTypeAttribute;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  value?: string | number;
  error?: string;
  readOnly?: boolean;
  variant?: "primary" | "secondary";
  placeholderPosition?: "left" | "center";
  icon?: IconName; 
  useOCRFont?: boolean;
  autoComplete?: string;
  min?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      placeholder,
      className,
      type = "text",
      onChange,
      name,
      value,
      error,
      readOnly = false,
      variant = "primary",
      placeholderPosition = "left",
      icon,
      useOCRFont = false,
      autoComplete = "on",
    },
    ref
  ) => (
    <div className={`flex flex-col gap-2 md:gap-1 ${className}`}>
      {label && <p className="font-medium">{label}</p>}

      <div className="relative w-full">
        {/* Icon on the left if provided */}
        {icon && (
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            <Icon name={icon} />
          </span>
        )}

        <input
          ref={ref}
          id={label}
          placeholder={placeholder}
          className={classNames(
            "text-field w-full h-[40px] border rounded-full border-[#9D9898] focus:shadow-[#3B82F640]/25 p-4 outline-none text-[12px] md:text-[14px]",
            {
              "text-style": useOCRFont,
              "bg-transparent": variant === "secondary",
              "bg-transparent border-[1px] primary-inputSd solid":
                variant === "primary",
              error: error,
              "pl-10": icon, // Add left padding when icon exists
              "text-left placeholder:text-left": placeholderPosition === "left",
              "text-center placeholder:text-center":
                placeholderPosition === "center",
            }
          )}
          onChange={onChange}
          value={value}
          type={type === "number" ? "text" : type}
          name={name}
          readOnly={readOnly}
          autoComplete={autoComplete}
        />
      </div>

      {error && (
        <span className="error-text text-[#FF0101] text-[12px]">{error}</span>
      )}
    </div>
  )
);

export default Input;
